import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import Popup from '../../Shared/Assets/Components/Popup';
import Dropdown from '../../Shared/Assets/Components/Dropdown';

import LogoSaveSearch from '-!svg-react-loader!./save-search-logo.svg';


const ContentContainer = styled.div`
    height: 450px;
    width: 500px;
`;

const MainContent = styled.div`
    min-height: 300px;
    text-align: center;
`;

const ContentTitle = styled.h3`
    color: #393939;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.23;
`;

const ContentText = styled.p`
    color: #808080;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
`;

const ContentButton = styled.a`
    background: #007cc2;
    border-radius: 100px;
    width: 200px;
    height: 50px;
    padding: 12px;
    display: block;
    margin: 30px auto 0 auto;

    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.6px;
    color: #fff !important;

    cursor: pointer;
`;

const FrequencyContent = styled.div`
    margin: 40px auto 10px auto;
    padding: 35px;
    width: 400px;
    height: 160px;

    background: #f2f2f2;
    border-radius: 6px;
`;

const FrequencyText = styled(ContentText)`
    color: #262626;
`;

const FrequencyInput = styled.input`
    margin: 0 auto;
    padding: 0 20px;
    width: 300px;
    height: 43px;

    border: 0.5px solid #b9b9b9;
    border-radius: 6px;
    
    font-size: 14px;
    color: #007cc2;
    line-height: 1.71;
    
    &:focus {
        outline: none;
    }
`;

const DropDownContainer = styled.div`
    margin: 0 auto;
    width: 300px;
    height: 43px;
`;

const FooterContent = styled.div`
    padding: 10px 0;
    
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    text-align: center;
    background: #f2f2f2;
    border-top: 1px solid #dbdbdb;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    
`;

const FooterText = styled.p`
    margin-bottom: 0;

    font-size: 14px;
    color: #262626;
    line-height: 1.43;
`;

const FooterLink = styled.a`
    color: #007cc2 !important;
    cursor: pointer;
`;

const ErrorMessage = styled.p`
    margin-bottom: 0;

    font-size: 14px;
    color: #f00;
    line-height: 1.43;
`;

const Logo = styled(LogoSaveSearch)`
    display: inline-block;
    margin: 50px 0;
`;

class SaveSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
            error: null,
            isSaved: false,

            frequency: 'Immediate',
            value: ''
        };
    }

    openModal = () => {
        this.setState({
            isModalOpen: true
        });
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    }

    handleInputChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    handleDropdownChange = (e) => {
        this.setState({
            frequency: e
        });
    }

    handleSignInClick = () => {
        let currentUrl = window.location.href;
        window.location.href = `${this.props.translations.signInUrl}?ret=${encodeURIComponent(currentUrl)}`;
    }

    handleSignUpClick = () => {
        let currentUrl = window.location.href;
        window.location.href = `${this.props.translations.signUpUrl}?ret=${encodeURIComponent(currentUrl)}`;
    }

    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        window._fbq = window._fbq || {};

        if (this.state.value === '' || this.state.value.length <= 3) {
            this.setState({
                error: "Please enter a name for your saved search with more than 3 characters"
            });

            return;
        }

        const { value, frequency } = this.state;
        const { searchContext, canSelectFrequency } = this.props;

        fetch(`${this.props.apiUrl}saved-searches/save`,
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: value,
                    frequency: canSelectFrequency ? frequency : "None",
                    searchContext: searchContext
                })
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.ok) {
                    this.setState({ isSaved: true });

                    window._fbq('trackcustom', 'save search', {
                        content_type: 'vehicle',
                        currency: "AUD",
                        value: 0
                    });

                    return;
                }

                this.setState({ error: response.errors.map(x => x.message).join(",") });
            })
            .catch((error) => {
                console.log("An error occurred->", error);
            });
    }

    render() {
        return (
            <div className="save-search__container" data-webm-section="listing-item">
                <span className="save-search__icon" />
                <span className="save-search__text btn btn-sm btn-outline" data-webm-clickvalue="save-search" onClick={this.openModal}>{this.props.text}</span>

                <Popup isOpen={this.state.isModalOpen} onRequestClose={this.closeModal} height={550} width={500}>
                    {!this.props.isAuthenticated ? (
                        <ContentContainer>
                            <MainContent>
                                <Logo />
                                <ContentTitle>{this.props.translations.headerText}</ContentTitle>
                                <ContentText>{this.props.translations.bodyText}</ContentText>
                                <ContentButton onClick={this.handleSignUpClick}>{this.props.translations.singUp}</ContentButton>
                            </MainContent>
                            <FooterContent>
                                <FooterText>
                                    {this.props.translations.member} <FooterLink onClick={this.handleSignInClick}>{this.props.translations.singIn}</FooterLink>
                                </FooterText>
                            </FooterContent>
                        </ContentContainer>
                    ) : (
                            <ContentContainer>
                                {!this.state.isSaved ? (
                                    <MainContent>
                                        <ContentTitle>Let's get started</ContentTitle>
                                        <ContentText>Name your search</ContentText>
                                        <FrequencyInput type="text" value={this.state.value} onChange={this.handleInputChange} />
                                        {this.state.error ? (<ErrorMessage>{this.state.error}</ErrorMessage>) : ('')}
                                        {this.props.canSelectFrequency && <FrequencyContent>
                                          <FrequencyText>How often would you like to be emailed?</FrequencyText>
                                          <DropDownContainer>
                                            <Dropdown boldedSelectedValue options={this.props.options} onChange={this.handleDropdownChange} />
                                          </DropDownContainer>
                                        </FrequencyContent>}
                                        <div></div>
                                        <ContentButton onClick={this.handleClick}>Save search</ContentButton>
                                    </MainContent>
                                ) : (
                                        <MainContent>
                                            <ContentTitle>All done</ContentTitle>
                                            <ContentText>Your search for {this.state.value} has been saved</ContentText>
                                            <ContentButton onClick={this.closeModal}>Finished</ContentButton>
                                        </MainContent>
                                    )}
                            </ContentContainer>
                        )}
                </Popup>
            </div>
        );
    }
}

SaveSearch.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.string,
    searchContext: PropTypes.string,
    isAuthenticated: PropTypes.bool,
    apiUrl: PropTypes.string,
    signInUrl: PropTypes.string,
    signUpUrl: PropTypes.string
};

export default SaveSearch;